import * as actions from '../../utils/Actions';

const initialState = {
    showPageLoader: false,
    submitSingleStepData:null,
    loginDetails:null,
    redirectUrl:null,
    submitPrimaryForm2Data :null,
    basicProfile:null
   
}

export default function admission(state = initialState, action){

    if (typeof state === 'undefined') {
        return state;
    }

    switch (action.type){

        case actions.RESET_LOGIN_DATA:
            return {
                ...state,
                loginDetails: null,
                redirectUrl:null,
                basicProfile:null
            }

        case actions.RESET_ADMISSION_DATA:
            return {
                ...state,
                submitSingleStepData:null,
            }

        case actions.pending(actions.SUBMIT_SINGLE_STEP):
            return {
                ...state,
                showPageLoader: true
            }

        case actions.fulfilled(actions.SUBMIT_SINGLE_STEP):
            return {
                ...state,
                submitSingleStepData: action.payload.data,
                showPageLoader: false
            }

        case actions.rejected(actions.SUBMIT_SINGLE_STEP):
            return {
                ...state,
                showPageLoader: false
            }

        case actions.pending(actions.LOGIN):
            return {
                ...state,
                showPageLoader: true
            }

        case actions.fulfilled(actions.LOGIN):
            return {
                ...state,
                loginDetails: action.payload.data,
                showPageLoader: false
            }

        case actions.rejected(actions.LOGIN):
            return {
                ...state,
                showPageLoader: false
            }

        case actions.pending(actions.INIT_PAYMENT):
            return {
                ...state,
                showPageLoader: true
            }

        case actions.fulfilled(actions.INIT_PAYMENT):
            return {
                ...state,
                redirectUrl: action.payload.data,
                showPageLoader: false
            }

        case actions.rejected(actions.INIT_PAYMENT):
            return {
                ...state,
                showPageLoader: false
            }

        case actions.pending(actions.SUBMIT_PRIMARY_FROM_2):
        return {
            ...state,
            showPageLoader: true
        }

        case actions.fulfilled(actions.SUBMIT_PRIMARY_FROM_2):
            return {
                ...state,
                submitPrimaryForm2Data: action.payload.data,
                showPageLoader: false
            }

        case actions.rejected(actions.SUBMIT_PRIMARY_FROM_2):
            return {
                ...state,
                showPageLoader: false
            }
            

        case actions.pending(actions.GET_PAYMENT_STATUS):
            return {
                ...state,
                showPageLoader: true,
                paymentStatus: null

            }

        case actions.fulfilled(actions.GET_PAYMENT_STATUS):
            
            return {
                ...state,
                showPageLoader: false,
                paymentStatus: action.payload.data

            }

        case actions.rejected(actions.GET_PAYMENT_STATUS):
            return {
                ...state,
                showPageLoader: false,
                paymentStatus: null
            } 
        case actions.pending(actions.BASIC_PROFILE):
            return {
                ...state,
                showPageLoader: true,
                basicProfile: null

            }

        case actions.fulfilled(actions.BASIC_PROFILE):
            
            return {
                ...state,
                showPageLoader: false,
                basicProfile: action.payload.data
            }

        case actions.rejected(actions.BASIC_PROFILE):
            return {
                ...state,
                showPageLoader: false,
                paymentStatus: null
            } 

            
            default:
                return {...state}
        }
    
    }